import AxiosJob from '@/services/api/job/axios_job'

export default {
  createDeliverableSetItem: (data) => {
    return AxiosJob.post('deliverable-set-item', data)
  },

  updateDeliverableSetItem: (deliverableSetItemId, data) => {
    return AxiosJob.put(`deliverable-set-item/${deliverableSetItemId}`, data)
  },

  getAllDeliverableSetItems: (params) => {
    return AxiosJob.get('deliverable-set-item', { params })
  },

  getDeliverableSetItem: (deliverableSetItemId) => {
    return AxiosJob.get(`deliverable-set-item/${deliverableSetItemId}`)
  },

  deleteDeliverableSetItem: (deliverableSetItemId) => {
    return AxiosJob.delete(`deliverable-set-item/${deliverableSetItemId}`)
  },

  getDeliverableSetItemsBySetId: (deliverableSetId, params) => {
    return AxiosJob.get(`deliverable-set-item/deliverable-set/${deliverableSetId}`, { params })
  },
}
